<template>
    <svg width="11" height="8" viewBox="0 0 11 9" xmlns="http://www.w3.org/2000/svg" class="icon-toggle">
        <path data-v-7ad9f9ed="" d="M5.5 9L10.2631 0.75H0.73686L5.5 9Z"></path>
    </svg>
</template>